import { render, staticRenderFns } from "./PhRobot.vue?vue&type=template&id=f77fe60c"
import script from "./PhRobot.vue?vue&type=script&lang=js"
export * from "./PhRobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports